<template>
  <div>
    <Nav :showMobileSearch="false" ref="Nav" />
    <div class="musician-detail">
      <div class="main-box">
        <div class="user-info">
          <!-- <div class="avatar"> 头像临时取消显示
            <img v-if="companyDetail.img" :src="avatar" alt="" />
            <div v-else-if="companyDetail.nameChs" 
              :class="'base-pic-placeholder-detail bg'+parseInt(Math.random()*6)">
              {{companyDetail.nameChs.substring(0,1)}}
            </div>
          </div> -->
          <div class="info" style="margin-left: 0px">
            <!--头像临时取消显示 margin-left: 0px;-->
            <div class="name" v-if="companyDetail.nameChs">
              {{ companyDetail.nameChs }}
            </div>
            <div
              :class="showMore ? 'desc cur' : 'desc'"
              v-if="companyDetail.description"
            >
              <p id="contentDesc">
                {{
                  Array.isArray(companyDetail.description)
                    ? companyDetail.description[0].substring(0,companyDetail.description.lastIndexOf('(')).replace(/[.]/g,'。').replace(/,/g,'，')
                    :  companyDetail.description.substring(0,companyDetail.description.lastIndexOf('(')).replace(/[.]/g,'。').replace(/,/g,'，')
                }}
              </p>
            </div>
            <a
              href="javascript:"
              :class="showMore ? 'more cur' : 'more'"
              @click="showMore = !showMore"
              >{{ showMore ? "收起" : "展开" }}<i></i
            ></a>
            <div class="btns">
              <ShareDialog ref="share"
                ><a href="javascript:" class="share" @click="handleShare()"
                  ><i></i>分享</a
                ></ShareDialog
              >
              <a
                href="javascript:"
                :class="isFav ? 'fav cur' : 'fav'"
                @click="handleSingleFav"
                ><i></i>收藏</a
              >
            </div>
          </div>
        </div>
        <div class="mb-des" v-if="companyDetail.description">
          <div :class="showMore ? 'desc cur' : 'desc'">
            <p>
              {{
                  Array.isArray(companyDetail.description)
                    ? companyDetail.description[0].substring(0,companyDetail.description.lastIndexOf('(')).replace(/[.]/g,'。').replace(/,/g,'，')
                    :  companyDetail.description.substring(0,companyDetail.description.lastIndexOf('(')).replace(/[.]/g,'。').replace(/,/g,'，')
                }}
            </p>
          </div>
          <a
            href="javascript:"
            :class="showMore ? 'more cur' : 'more'"
            @click="showMore = !showMore"
            >{{ showMore ? "收起" : "展开" }}<i></i
          ></a>
        </div>
        <div class="result-count">
          <span
            >唱片<b>{{ recordCount }}</b>种</span
          >
       
          <div class="sort">
            <span :class="sorts[0] ? 'cur' : ''" @click="onSorts(0)">题名</span>
            <span :class="sorts[1] ? 'cur' : ''" @click="onSorts(1)"
              >出版时间</span
            >
            <span :class="sorts[2] ? 'cur' : ''" @click="onSorts(2)"
              >责任者</span
            >
            
            <span
              :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
              @click="onlyCanPlay"
              >可播放唱片</span
            >
          </div>
        </div>
        <div class="record-list">
          <div
            v-for="(item, index) in recordList"
            :key="'recordList' + index"
            class="record-cell"
          >
           <div class="pic" >
                    <router-link :to="'/rec-info/'+encodeURIComponent(item['@id'])" v-if="item.title"> 
                  <img
                    v-if="item.cover[0]"
                    :src="
                      'https://img.library.sh.cn/hisdata/cp/img/' +
                      item.cover[0]
                    "
                    alt=""
                  />
                  <img v-else :src="baseRecordPic" alt="" />
                  </router-link>
                    <div v-if="item.playable" class="h-box" @click="playSong(item, index)">
                    </div>
                </div>
            <router-link
              :to="'/rec-info/' + encodeURIComponent(item['@id'])"
              class="tit"
              v-if="item.dcTitle"
            >
              {{ item.dcTitle["@value"] }}
            </router-link>
            <div class="info" v-if="item.creator">{{ item.creator }}</div>
            <div v-if="!isMobile && item.date" class="info">{{ item.date }}</div>
            <!-- <div class="info">{{item.type}}</div>
            <div class="info">{{item.date}}</div> -->
          </div>
          <div class="clear-f"></div>
        </div>
        <div class="page-box">
          <a-pagination
            :total="pagerCount"
            :current="currentPage"
            @change="onChange"
            show-quick-jumper
            show-less-items
          />
        </div>
      </div>
    </div>
    <Footer />

    <Player ref="player" @curPlay="curPlay"/>
  </div>
</template>

<script>
import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from "@/components/player";
import ShareDialog from "@/components/shareDialog";
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);
import { baseRecordPic } from "@/util/basePic";
import {
  orgInfo,
  phonorecordSearchGet,
  phonorecordInfo,
  collFav,
  ncollFav,
} from "@/api";

export default {
  components: {
    Nav,
    Footer,
    Player,
    ShareDialog,
  },
  data() {
    return {
      isMobile,
      sc: false,
      loginHref: null,
      isFav: false,
      visible: false,
      playIndex:-1,
      curIndex:-1,
      noplay: false,
      hasAudio: false, //是否可播放标记 chenss
      onlyShowPlay: false, //是否可播放标记 chenss
      cm: [],
      queryUri: decodeURIComponent(this.$route.params.id),
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {
        // 检索参数
        field: "PROURI",
        value: "",
        sort: "TI",
        order: 1,
        PLAY: "", //是否可播放，默认全部查询 chenss
        pageth: 1,
        pageSize: 10,
      },
      pagerCount: 1,
      currentPage: 1, // 当前页码
      baseRecordPic,
      avatar: require("./../../../public/img/demo/image.png"),
      showMore: false,
      companyDetail: {},
      recordCount: 0,
      recordList: [],
      sorts: [true, false, false],
    };
  },
   watch: {//解决此画面打开时，再从浏览器通过其他参数打开该画面 能正常打开
    $route(to, from) {
      var id = this.$route.params.id;
      //console.log("route change", id);

      this.queryUri = decodeURIComponent(this.$route.params.id);
      this.query();
    },
  },
  mounted() {
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href;
    this.$nextTick(() => {
      if(this.GLOBAL.BASE_IP_INFO.ipIsInner){//如果是内网，直接勾选可播放按钮 chenss 20220831
        // 仅显示可播放唱片
        this.onlyShowPlay = true;
        this.hasAudio = this.onlyShowPlay;
        this.searchParams.PLAY = "1";
      }
      this.query();
    });
  },
  beforeRouteLeave(to, form, next) {
    this.$refs.player.savePlayer();
    next();
  },
  methods: {
    async query() {
      // 查询
      const res = await orgInfo({ uri: this.queryUri });
      const result = res.data;
      this.companyDetail = result.datas;
      this.isFav = result.datas.isFavorite;
      this.phonorecordSearchGet();
    },
    onlyCanPlay() {
      // 仅显示可播放唱片
      this.onlyShowPlay = !this.onlyShowPlay;
      this.hasAudio = this.onlyShowPlay;
      //console.log(this.hasAudio);
      this.searchParams.PLAY = "";
      if (this.hasAudio) {
        this.searchParams.PLAY = "1";
      }
      this.phonorecordSearchGet();
    },
    async phonorecordSearchGet(name) {
      this.searchParams.sort = "";
      if (this.sorts[0]) this.searchParams.sort = "TI";
      if (this.sorts[1]) this.searchParams.sort = "TIME";
      if (this.sorts[2]) this.searchParams.sort = "CO";
      this.searchParams.value = this.queryUri;
      this.searchParams.pageth = this.currentPage;
      const res = await phonorecordSearchGet(this.searchParams);
      const result = res.data;
      this.recordList = result.datas;
      this.recordCount = result.pager.rowCount;
      // 页码
      this.pagerCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 1;
    },
    curPlay(){
      this.playIndex = this.curIndex;
    },
    async playSong(item,index) {
      this.curIndex = index;
      this.$refs.player.playSong(this.$refs.Nav, item);
    },
    async handleSingleFav() {
      if (!localStorage.getItem("token")) {
        this.$refs.Nav.showTk(2);
        return;
      }
      const res = this.isFav
        ? await ncollFav({ uri: this.companyDetail["@id"] })
        : await collFav({ uri: this.companyDetail["@id"] });

      this.isFav = !this.isFav;
      this.$refs.Nav.cpnclick(this.isFav);
    },
    onSorts(n) {
      // 排序
      // this.sorts = [false,false,false];
      // 排序
      this.sorts.splice(n, 1, !this.sorts[n]);
      let allFalse = 1
      this.sorts.forEach((item, index) => {
        if (n != index) {
          this.sorts[index] = false;
        }
        if(item == true){
          allFalse = 2
        }
      });
      if(allFalse == 1){
        this.sorts[0] = true;
      }
      this.phonorecordSearchGet(false);
    },
    onChange(current) {
      // 页码点击
      //console.log(current,"current")
      this.currentPage = current;
      this.phonorecordSearchGet();
    },
    handleOk() {
      this.isLogin = false;
    },
    handleCancel() {
      this.visible = false;
    },
    nohandleCancel() {
      this.noplay = false;
    },
    schandleCancel() {
      this.sc = false;
    },
    handleShare() {
      // this.$refs.share.visible=!this.$refs.share.visible
      this.$refs.share.show();
    },
  },
};
</script>
